module.exports = __webpack_public_path__ + "static/media/thumb_3.fb704367.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Images/thumb_3.png
// module id = 79
// module chunks = 0